module.exports = __webpack_public_path__ + "static/media/logo-05.b37a322e.png";